import { Box, Typography } from "@mui/material";
import { DateTime } from "luxon";
import React, { useRef, useState } from "react";

import { EnhancedCenter } from "../../../Models/Center";
import useInterval from "../../../Utils/useInterval";

interface Props {
  center?: EnhancedCenter;
}

const Clock: React.FC<Props> = ({ center }: Props) => {
  const [time, setTime] = useState(DateTime.now().toLocaleString(DateTime.TIME_SIMPLE));
  const localZoneRef = useRef(DateTime.now().zone);
  useInterval(
    () => setTime(DateTime.now().setZone(center?.luxonTimeZone.name).toLocaleString(DateTime.TIME_SIMPLE)),
    1000
  );
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Typography variant="body2">{time}</Typography>
      {center?.luxonTimeZone && center.luxonTimeZone.name != localZoneRef.current.name && (
        <Typography variant="body2">In Center</Typography>
      )}
    </Box>
  );
};

export default Clock;
